import NewCardPaymentForm from './NewCardPaymentForm'

export default NewCardPaymentForm
